export const onceTransitionEnd = (el, fn) => {
  addTransitionEndListener(el, e => {
    removeTransitionEndListener(el, fn)
    fn(e)
  })
}

export const addTransitionEndListener = (el, fn) => {
  el.addEventListener('transitionend', fn)
  el.addEventListener('webkitTransitionEnd', fn)
}

export const removeTransitionEndListener = (el, fn) => {
  el.removeEventListener('transitionend', fn)
  el.removeEventListener('webkitTransitionEnd', fn)
}
